(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .factory('HubspotLeadSearch', HubspotLeadSearch);

    HubspotLeadSearch.$inject = ['$resource'];

    function HubspotLeadSearch($resource) {
        var resourceUrl =  'api/_search/hubspot-leads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
